import axios from 'axios';
// import { getToken, getBaseUrl, removeToken } from '../utils/sessionstorage.js';

const axiosInst = axios.create({
  // baseURL: getBaseUrl(),
  timeout: 5 * 60 * 1000,
});

// axiosInst.interceptors.request.use(
//   config => {
//     if (getToken()) {
//       config.headers.Authorization = `Bearer ${getToken()}`;
//     }
//     // config.withCredentials = true;
//     return config;
//   },
//   err => {
//     return Promise.reject(err);
//   }
// );

axiosInst.interceptors.response.use(
  response => response.data,
  error => {
    let errResponseStatus = error && error.response && error.response.status
    console.error(error.response?.data || error.message);
    console.error(errResponseStatus);
    // if (errResponseStatus === 401) {
    //   removeToken();
    //   window.location.href = '/portal/login'
    //   return;
    // }
    // if (errResponseStatus === 502) {
    //   console.error({
    //     message: "Gateway Timeout Error", //error.message,
    //     duration: 0,
    //     btn: (<a onClick={() => { window.location.reload(); }}>Refresh</a>)
    //   });
    //   return;
    // }
    let errorMsg = error.message;
    // console.log("Error", error);
    if (error.response && error.response.data && error.response.data.error) {
      errorMsg = error.response.data.error;
    }
    return Promise.reject(error);
  }
);

export default axiosInst;
